import React, { useState, useEffect } from "react";
import videojs from "video.js";
import { Link, useParams } from "react-router-dom";
import { Dropdown, Row, Col, Container, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import { GetContentThunk } from "../../../store/redux/SLICE/auth/Content";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL } from "../../../BaseUrl";
import axios from "axios";
import { TMDB_CONFIG, getImageUrl, getPosterUrl } from "../../../config/tmdb";

import "swiper/swiper-bundle.css";
import "videojs-seek-buttons/dist/videojs-seek-buttons.css";
import "videojs-contrib-quality-levels/dist/videojs-contrib-quality-levels";
import "videojs-seek-buttons";

import banner from "../../../assets/images/movie-banner/1.jpg";

import star1 from "../../../assets/images/star/star1.jpg";
import star2 from "../../../assets/images/star/star2.jpg";

// upcoming img
import upcoming1 from "../../../assets/images/upcoming/01.jpg";
import upcoming2 from "../../../assets/images/upcoming/02.jpg";
import upcoming3 from "../../../assets/images/upcoming/03.jpg";
import upcoming4 from "../../../assets/images/upcoming/04.jpg";
import upcoming5 from "../../../assets/images/upcoming/05.jpg";
import VideoJS from "../pages/video";
import ReactPlayer from "react-player";
import video from "../../../assets/video/Minions.mp4";
import videoplayer from "video.js";
import { toast } from "react-toastify";
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";


const MovieDetails = () => {
  const { id: routeMovieId } = useParams();
  console.log("Movie ID from URL:", routeMovieId);
  const [activeTab, setActiveTab] = useState("description");
  const playerRef = React.useRef(null);
  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const moviesContent = store && store?.contents?.contents;
  console.log(moviesContent, "moviesContent User store");

  // TMDB state
  const [tmdbMovie, setTmdbMovie] = useState({
    id: null,
    title: "",
    overview: "",
    vote_average: null,
    release_date: "",
    backdrop_path: null,
    poster_path: null,
    runtime: null,
    genres: [],
    adult: false,
  });
  const [tmdbTrailerKey, setTmdbTrailerKey] = useState("");
  const [showTrailerInline, setShowTrailerInline] = useState(false);
  const [tmdbLoading, setTmdbLoading] = useState(false);
  const [tmdbError, setTmdbError] = useState(null);

  // TV Videos state
  const [tvVideos, setTvVideos] = useState({
    videos: [],
    loading: false,
    error: null
  });
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [showFullScreenPlayer, setShowFullScreenPlayer] = useState(false);

  // Similar Movies state
  const [similarMovies, setSimilarMovies] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // Watch Providers state
  const [watchProviders, setWatchProviders] = useState({
    providers: [],
    loading: false,
    error: null
  });

  // Movie Credits state
  const [movieCredits, setMovieCredits] = useState({
    cast: [],
    crew: [],
    loading: false,
    error: null
  });

  // Movie Reviews state
  const [movieReviews, setMovieReviews] = useState({
    reviews: [],
    loading: false,
    error: null
  });

  // Form state for review form
  const [formData, setFormData] = useState({
    author: "",
    email: "",
    comment: "",
    rating: 0
  });

  // User Rating state
  const [userRating, setUserRating] = useState({
    rating: 0,
    hasRated: false,
    submitting: false,
    deleting: false,
    error: null,
    success: null
  });

  useEffect(() => {
    dispatch(GetContentThunk());
  }, [dispatch]);

  // Fetch TMDB movie details and videos by ID from route
  useEffect(() => {
    const movieId = routeMovieId || null;
    console.log("=== MOVIE DETAILS DEBUG ===");
    console.log("Route Movie ID:", routeMovieId);
    console.log("Movie ID extracted:", movieId);
    console.log("TMDB Config:", TMDB_CONFIG);
    
    if (!movieId) {
      console.log("❌ No movie ID found in route params");
      return;
    }
    
    const fetchDetailsAndVideos = async () => {
      try {
        setTmdbLoading(true);
        setTmdbError(null);
        
        console.log("🚀 Fetching TMDB data for movie ID:", movieId);
        
        // Check if JWT token is configured
        if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
          throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
        }

        // Details
        const detailsUrl = `${TMDB_CONFIG.BASE_URL}/movie/${movieId}?language=en-US`;
        const videosUrl = `${TMDB_CONFIG.BASE_URL}/movie/${movieId}/videos?language=en-US`;
        const headers = {
          accept: "application/json",
          Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`,
        };
        
        console.log("📡 Making API calls to:", detailsUrl, videosUrl);
        console.log("🔑 Using JWT Token:", TMDB_CONFIG.JWT_TOKEN.substring(0, 20) + "...");
        
        const [detailsRes, videosRes] = await Promise.all([
          axios.get(detailsUrl, { headers }),
          axios.get(videosUrl, { headers }),
        ]);

        const d = detailsRes.data || {};
        console.log("✅ TMDB Movie Details Response:", d);
        
        setTmdbMovie({
          id: d.id,
          title: d.title || d.original_title || "",
          overview: d.overview || "",
          vote_average: d.vote_average || null,
          release_date: d.release_date || "",
          backdrop_path: d.backdrop_path || null,
          poster_path: d.poster_path || null,
          runtime: d.runtime || null,
          genres: d.genres || [],
          adult: d.adult || false,
        });

        const results = (videosRes.data && videosRes.data.results) || [];
        console.log("🎬 TMDB Videos Response:", results);
        
        const trailer = results.find(
          (v) => (v.type === "Trailer" || v.type === "Teaser") && v.site === "YouTube"
        );
        
        if (trailer) {
          console.log("🎥 Found trailer:", trailer);
          setTmdbTrailerKey(trailer.key);
          // Autoplay trailer inline when available
          setShowTrailerInline(true);
        } else {
          console.log("❌ No trailer found");
          setTmdbTrailerKey("");
          setShowTrailerInline(false);
        }
        
        console.log("✅ TMDB data fetch completed successfully!");
        
      } catch (err) {
        console.error("❌ Failed to fetch TMDB movie details/videos:", err);
        console.error("Error details:", err.response?.data || err.message);
        setTmdbError(err.message || "Failed to load movie details");
      } finally {
        setTmdbLoading(false);
      }
    };
    
    fetchDetailsAndVideos();
    fetchSimilarMovies(routeMovieId);
    fetchWatchProviders(routeMovieId);
    fetchMovieCredits(routeMovieId);
    fetchMovieReviews(routeMovieId);
  }, [routeMovieId]);

  // Fetch TV Videos by series ID
  const fetchTVVideos = async (seriesId) => {
    setTvVideos(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/tv/${seriesId}/videos?language=en-US`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const videos = response.data.results || [];
      
      setTvVideos({
        videos: videos,
        loading: false,
        error: null
      });
      
      console.log("TV Videos fetched:", videos);
    } catch (error) {
      console.error("Failed to fetch TV videos:", error);
      setTvVideos(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch videos"
      }));
    }
  };

  // Handle play video (mediaType: 'movie' | 'tv')
  const handlePlayVideo = async (mediaId, mediaType = 'movie') => {
    try {
      // If no videos loaded yet, fetch them first
      if (tvVideos.videos.length === 0) {
        setTvVideos(prev => ({ ...prev, loading: true, error: null }));
        
        const options = {
          method: 'GET',
          url: mediaType === 'tv'
            ? `https://api.themoviedb.org/3/tv/${mediaId}/videos?language=en-US`
            : `https://api.themoviedb.org/3/movie/${mediaId}/videos?language=en-US`,
          headers: {
            accept: 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
          }
        };

        const response = await axios.request(options);
        const videos = response.data.results || [];
        
        setTvVideos({
          videos: videos,
          loading: false,
          error: null
        });
        
        // Find the best video after loading
        const video = videos.find(v => v.type === "Trailer") ||
                      videos.find(v => v.type === "Teaser") ||
                      videos[0];
        
        if (video) {
          setSelectedVideo(video);
          setShowFullScreenPlayer(true);
        } else {
          console.log("No videos found for this series");
          toast.error("No videos available for this content");
        }
      } else {
        // Videos already loaded, find and play
        const video = tvVideos.videos.find(v => v.type === "Trailer") ||
                      tvVideos.videos.find(v => v.type === "Teaser") ||
                      tvVideos.videos[0];
        
        if (video) {
          setSelectedVideo(video);
          setShowFullScreenPlayer(true);
        }
      }
    } catch (error) {
      console.error("Failed to fetch or play video:", error);
      setTvVideos(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to load video"
      }));
      toast.error("Failed to load video. Please try again.");
    }
  };

  // Fetch Similar Movies by movie ID
  const fetchSimilarMovies = async (movieId) => {
    setSimilarMovies(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/movie/${movieId}/similar?language=en-US&page=1`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const movies = (response.data.results || []).slice(0, 10).map(movie => ({
        title: movie.title,
        imageUrl: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        ageRating: movie.adult ? '18+' : '13+',
        duration: '2h 30m',
        id: movie.id,
        vote_average: movie.vote_average,
        release_date: movie.release_date,
        overview: movie.overview
      }));

      setSimilarMovies({
        movies: movies,
        loading: false,
        error: null
      });

      console.log("Similar movies fetched:", movies);
    } catch (error) {
      console.error("Failed to fetch similar movies:", error);
      setSimilarMovies(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch similar movies"
      }));
    }
  };

  // Fetch Watch Providers by movie ID
  const fetchWatchProviders = async (movieId) => {
    setWatchProviders(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/movie/${movieId}/watch/providers`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const results = response.data.results || {};
      const usProviders = results.US || {};
      
      const providers = {
        buy: usProviders.buy || [],
        rent: usProviders.rent || [],
        flatrate: usProviders.flatrate || [],
        free: usProviders.free || []
      };

      setWatchProviders({
        providers: providers,
        loading: false,
        error: null
      });

      console.log("Watch providers fetched:", providers);
    } catch (error) {
      console.error("Failed to fetch watch providers:", error);
      setWatchProviders(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch watch providers"
      }));
    }
  };

  // Fetch Movie Credits by movie ID
  const fetchMovieCredits = async (movieId) => {
    setMovieCredits(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/movie/${movieId}/credits?language=en-US`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const credits = response.data || {};
      
      // Get top 10 cast members
      const cast = (credits.cast || []).slice(0, 10).map(actor => ({
        id: actor.id,
        name: actor.name,
        character: actor.character,
        profile_path: actor.profile_path,
        profile_image_url: actor.profile_path 
          ? `https://image.tmdb.org/t/p/w185${actor.profile_path}` 
          : 'https://via.placeholder.com/185x278/333/fff?text=No+Image'
      }));

      // Get key crew members (director, writer, etc.)
      const crew = (credits.crew || []).filter(member => 
        ['Director', 'Writer', 'Screenplay', 'Producer'].includes(member.job)
      ).slice(0, 5).map(member => ({
        id: member.id,
        name: member.name,
        job: member.job,
        profile_path: member.profile_path,
        profile_image_url: member.profile_path 
          ? `https://image.tmdb.org/t/p/w185${member.profile_path}` 
          : 'https://via.placeholder.com/185x278/333/fff?text=No+Image'
      }));

      setMovieCredits({
        cast: cast,
        crew: crew,
        loading: false,
        error: null
      });

      console.log("Movie credits fetched:", { cast, crew });
    } catch (error) {
      console.error("Failed to fetch movie credits:", error);
      setMovieCredits(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch movie credits"
      }));
    }
  };

  // Fetch Movie Reviews by movie ID
  const fetchMovieReviews = async (movieId) => {
    setMovieReviews(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: `https://api.themoviedb.org/3/movie/${movieId}/reviews?language=en-US&page=1`,
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const reviewsData = response.data || {};
      
      // Process reviews data
      const reviews = (reviewsData.results || []).map(review => ({
        id: review.id,
        author: review.author,
        content: review.content,
        created_at: review.created_at,
        updated_at: review.updated_at,
        url: review.url,
        rating: review.author_details?.rating || null,
        avatar_path: review.author_details?.avatar_path,
        avatar_url: review.author_details?.avatar_path 
          ? `https://image.tmdb.org/t/p/w45${review.author_details.avatar_path}` 
          : 'https://via.placeholder.com/45x45/333/fff?text=User'
      }));

      setMovieReviews({
        reviews: reviews,
        loading: false,
        error: null
      });

      console.log("Movie reviews fetched:", reviews);
    } catch (error) {
      console.error("Failed to fetch movie reviews:", error);
      setMovieReviews(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch movie reviews"
      }));
    }
  };

  // Submit Movie Rating
  const submitRating = async (movieId, rating) => {
    setUserRating(prev => ({ ...prev, submitting: true, error: null, success: null }));
    try {
      const options = {
        method: 'POST',
        url: `https://api.themoviedb.org/3/movie/${movieId}/rating`,
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        },
        data: {
          value: rating
        }
      };

      const response = await axios.request(options);
      
      setUserRating(prev => ({
        ...prev,
        rating: rating,
        hasRated: true,
        submitting: false,
        success: `Rating of ${rating}/10 submitted successfully!`
      }));

      console.log("Rating submitted successfully:", response.data);
      
      // Show success toast
      toast.success(`Rating of ${rating}/10 submitted successfully!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

    } catch (error) {
      console.error("Failed to submit rating:", error);
      setUserRating(prev => ({
        ...prev,
        submitting: false,
        error: error.response?.data?.status_message || error.message || "Failed to submit rating"
      }));

      // Show error toast
      toast.error(error.response?.data?.status_message || "Failed to submit rating", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  // Delete Movie Rating
  const deleteRating = async (movieId) => {
    setUserRating(prev => ({ ...prev, deleting: true, error: null, success: null }));
    try {
      const options = {
        method: 'DELETE',
        url: `https://api.themoviedb.org/3/movie/${movieId}/rating`,
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      
      setUserRating(prev => ({
        ...prev,
        rating: 0,
        hasRated: false,
        deleting: false,
        success: "Rating deleted successfully!"
      }));

      console.log("Rating deleted successfully:", response.data);
      
      // Show success toast
      toast.success("Rating deleted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

    } catch (error) {
      console.error("Failed to delete rating:", error);
      setUserRating(prev => ({
        ...prev,
        deleting: false,
        error: error.response?.data?.status_message || error.message || "Failed to delete rating"
      }));

      // Show error toast
      toast.error(error.response?.data?.status_message || "Failed to delete rating", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    techOrder: ["html5"],
    sources: [
      { src: "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4", type: "video/mp4" },
    ],
    controlBar: {
      skipButtons: { forward: 10, backward: 10 },
    },
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on("waiting", () => {
      videojs.log("player is waiting");
    });

    player.on("dispose", () => {
      videojs.log("player will dispose");
    });
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Play trailer inline (using ReactPlayer for YouTube)
  const playTrailerInline = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (tmdbTrailerKey) {
      setShowTrailerInline(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.author.trim()) {
      toast.error("Please enter your name");
      return;
    }
    if (!formData.email.trim()) {
      toast.error("Please enter your email");
      return;
    }
    if (!formData.comment.trim()) {
      toast.error("Please enter your review");
      return;
    }
    if (formData.rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    // Submit rating to TMDB
    await submitRating(routeMovieId, formData.rating);
    
    // Reset form after successful submission
    setFormData({
      author: "",
      email: "",
      comment: "",
      rating: 0
    });
  };

  // Handle star rating click
  const handleStarClick = (rating) => {
    setFormData(prev => ({
      ...prev,
      rating: rating
    }));
  };

  const upcomingData = [
    {
      title: "The Last Breath",
      imageUrl: upcoming1,
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      title: "Shadow",
      imageUrl: upcoming2,
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      title: "Another Danger",
      imageUrl: upcoming3,
      ageRating: "25+",
      duration: "3h",
    },
    {
      title: "1980",
      imageUrl: upcoming4,
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      title: "Vugotronic",
      imageUrl: upcoming5,
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];
  const related = [
    {
      title: "The Last Breath",
      imageUrl: upcoming1,
      ageRating: "5+",
      duration: "2h 30m",
    },
    {
      title: "Shadow",
      imageUrl: upcoming2,
      ageRating: "22+",
      duration: "2h 15m",
    },
    {
      title: "Another Danger",
      imageUrl: upcoming3,
      ageRating: "25+",
      duration: "3h",
    },
    {
      title: "1980",
      imageUrl: upcoming4,
      ageRating: "11+",
      duration: "2h 45m",
    },
    {
      title: "Vugotronic",
      imageUrl: upcoming5,
      ageRating: "9+",
      duration: "2h 30m",
    },
  ];

  const handleLinkClick = () => {
    window.scrollTo(0, 0); 
  };

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url);
  };

  return (
    <div>
      {tmdbLoading && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', width: '100%' }}>
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <h3 className="text-white">Loading Movie Details...</h3>
            <p className="text-white-50">Fetching data from TMDB</p>
          </div>
        </div>
      )}
      {tmdbError && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', width: '100%' }}>
          <div className="text-center">
            <h3 className="text-white">Error Loading Movie Details</h3>
            <p className="text-white-50">{tmdbError}</p>
            <button 
              className="btn btn-primary mt-3"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        </div>
      )}
      {!tmdbLoading && !tmdbError && (
        <>
          <div className="mb-4">
            {showTrailerInline && tmdbTrailerKey ? (
              <ReactPlayer
                url={`https://www.youtube.com/watch?v=${tmdbTrailerKey}`}
                controls
                playing
                width="100%"
                height="60vh"
              />
            ) : (
              <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
            )}
          </div>

      <div className="main-content movi ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="trending-info mt-4 pt-0 pb-4">
                <div className="row">
                  <div className="col-md-9 col-12  mb-auto">
                    <div className="d-md-flex">
                      <h3
                        className="trending-text big-title text-uppercase mt-0 fadeInLeft animated"
                        data-animation-in="fadeInLeft"
                        data-delay-in="0.6"
                        style={{
                          opacity: "1",
                          animationDelay: "0.6s",
                        }}
                      >
                        {tmdbMovie.title || "Movie"}
                      </h3>
                      <div className="slider-ratting d-flex align-items-center ml-md-3 ml-0">
                        <ul className="ratting-start p-0 m-0 list-inline text-primary d-flex align-items-center justify-content-left">
                          <li>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </li>
                          <li>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </li>
                          <li>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </li>
                          <li>
                            <i className="fa fa-star" aria-hidden="true"></i>
                          </li>
                          <li>
                            <i
                              className="fa fa-star-half"
                              aria-hidden="true"
                            ></i>
                          </li>
                        </ul>
                        <span className="text-white ml-2">
                          {tmdbMovie.vote_average ? tmdbMovie.vote_average.toFixed(1) : "N/A"} (TMDB)
                        </span>
                      </div>
                    </div>
                    <ul className="p-0 mt-2 list-inline d-flex flex-wrap movie-content">
                      {tmdbMovie.genres && tmdbMovie.genres.length > 0 ? (
                        tmdbMovie.genres.map((genre, index) => (
                          <li key={index} className="trending-list">
                            <a
                              className="text-primary title"
                              href="#"
                            >
                              {genre.name}
                              {index < tmdbMovie.genres.length - 1 ? ", " : ""}
                            </a>
                          </li>
                        ))
                      ) : (
                        <li className="trending-list">
                          <a className="text-primary title" href="#">
                            Drama
                          </a>
                        </li>
                      )}
                    </ul>
                    <div className="d-flex flex-wrap align-items-center text-white text-detail flex-wrap mb-4">
                      <span className="badge badge-secondary font-size-16">
                        {tmdbMovie.adult ? '18+' : 'PG'}
                      </span>
                      <span className="ml-3 font-Weight-500 genres-info">
                        {tmdbMovie.runtime ? `${Math.floor(tmdbMovie.runtime / 60)}h ${tmdbMovie.runtime % 60}m` : 'N/A'}
                      </span>
                      <span className="trending-year trending-year-list font-Weight-500 genres-info">
                        {tmdbMovie.release_date ? tmdbMovie.release_date.substring(0, 4) : ""}
                      </span>
                      <span className="trending-year trending-year-list single-view-count font-Weight-500 genres-info">
                        <i className="fa fa-eye"></i>1449 views
                      </span>
                    </div>
                    <ul className="list-inline p-0 m-0 share-icons music-play-lists mb-1">
                      <li className="share">
                        <span>
                          <i className="ri-share-fill"></i>
                        </span>
                        <div className="share-box">
                          <div className="d-flex align-items-center">
                            <a
                              href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                              className="share-ico"
                              target="_blank"
                            >
                              <i className="ri-facebook-fill"></i>
                            </a>
                            <a
                              href="https://twitter.com/intent/tweet?text=Currentlyreading"
                              className="share-ico"
                              target="_blank"

                            >
                              <i className="ri-twitter-fill"></i>
                            </a>
                            <a onClick={copyURL} className="share-ico">
                              <i className="ri-links-fill"></i>
                            </a>
                          </div>
                        </div>
                      </li>
                      <CompactWatchlistButtons item={{
                        id: tmdbMovie.id,
                        title: tmdbMovie.title,
                        type: 'movie',
                        poster_path: tmdbMovie.poster_path,
                        imgSrc: tmdbMovie.poster_path ? `https://image.tmdb.org/t/p/w500${tmdbMovie.poster_path}` : null,
                        vote_average: tmdbMovie.vote_average,
                        release_date: tmdbMovie.release_date,
                        overview: tmdbMovie.overview,
                        adult: tmdbMovie.adult
                      }} />
                    </ul>
                    <ul className="p-0 list-inline d-flex flex-wrap align-items-center mb-3 mt-4 iq_tag-list">
                      <li className="text-primary text-lable mr-3">
                        <i className="fa fa-tags" aria-hidden="true"></i>Tags:
                      </li>
                      {tmdbMovie.genres && tmdbMovie.genres.length > 0 ? (
                        tmdbMovie.genres.map((genre, index) => (
                          <li key={index} className="trending-list mr-3">
                            <a className="title" href="#">
                              {genre.name}
                              {index < tmdbMovie.genres.length - 1 ? ", " : ""}
                            </a>
                          </li>
                        ))
                      ) : (
                        <>
                          <li className="trending-list mr-3">
                            <a className="title" href="#">
                              Adventure,
                            </a>
                          </li>
                          <li className="trending-list mr-3">
                            <a className="title" href="#">
                              Comedy,
                            </a>
                          </li>
                          <li className="trending-list mr-3">
                            <a className="title" href="#">
                              Thriller
                            </a>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                  <div className="trailor-video col-md-3 col-12 mt-lg-0 mt-4 mb-md-0 mb-1 text-lg-right">
                    {tmdbTrailerKey ? (
                      <a
                        href="#"
                        onClick={(e)=>{e.preventDefault(); handlePlayVideo(routeMovieId, 'movie');}}
                        className="video-open playbtn block-images position-relative playbtn_thumbnail"
                      >
                        <img
                          width="1920"
                          height="1080"
                          src={tmdbMovie.backdrop_path ? getImageUrl(tmdbMovie.backdrop_path) : banner}
                          className="attachment-medium-large size-medium-large wp-post-image"
                          alt={tmdbMovie.title}
                          loading="lazy"
                          sizes="(min-width: 960px) 75vw, 100vw"
                        />
                        <span className="content btn btn-transparant iq-button">
                          {tvVideos.loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin mr-2"></i>
                              <span>Loading...</span>
                            </>
                          ) : (
                            <>
                              <i className="fa fa-play mr-2"></i>
                              <span>Play Movie</span>
                            </>
                          )}
                        </span>
                      </a>
                    ) : (
                      <div className="block-images position-relative playbtn_thumbnail">
                        <img
                          width="1920"
                          height="1080"
                          src={tmdbMovie.backdrop_path ? getImageUrl(tmdbMovie.backdrop_path) : banner}
                          className="attachment-medium-large size-medium-large wp-post-image"
                          alt={tmdbMovie.title}
                          loading="lazy"
                          sizes="(min-width: 960px) 75vw, 100vw"
                        />
                        <span className="content btn btn-transparant iq-button">
                          <span>No Trailer</span>
                        </span>
                      </div>
                    )}
                    
                    {/* Watch Providers Section */}
                    {watchProviders.providers && (
                      <div className="watch-providers mt-3">
                        <h6 className="text-white mb-2">Available on:</h6>
                        <div className="providers-container">
                          {watchProviders.loading ? (
                            <div className="text-center">
                              <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading providers...</span>
                              </div>
                            </div>
                          ) : watchProviders.error ? (
                            <p className="text-warning">Unable to load providers</p>
                          ) : (
                            <div className="row">
                              {/* Streaming Services */}
                              {watchProviders.providers.flatrate && watchProviders.providers.flatrate.length > 0 && (
                                <div className="col-12 mb-2">
                                  <small className="text-muted">Streaming:</small>
                                  <div className="d-flex flex-wrap">
                                    {watchProviders.providers.flatrate.map((provider, index) => (
                                      <div key={index} className="provider-item mr-2 mb-1">
                                        <img
                                          src={provider.logo_path ? `https://image.tmdb.org/t/p/w45${provider.logo_path}` : ''}
                                          alt={provider.provider_name}
                                          className="provider-logo"
                                          style={{width: '30px', height: '30px', objectFit: 'contain'}}
                                        />
                                        <small className="text-white ml-1">{provider.provider_name}</small>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              
                              {/* Free Services */}
                              {watchProviders.providers.free && watchProviders.providers.free.length > 0 && (
                                <div className="col-12 mb-2">
                                  <small className="text-muted">Free:</small>
                                  <div className="d-flex flex-wrap">
                                    {watchProviders.providers.free.map((provider, index) => (
                                      <div key={index} className="provider-item mr-2 mb-1">
                                        <img
                                          src={provider.logo_path ? `https://image.tmdb.org/t/p/w45${provider.logo_path}` : ''}
                                          alt={provider.provider_name}
                                          className="provider-logo"
                                          style={{width: '30px', height: '30px', objectFit: 'contain'}}
                                        />
                                        <small className="text-white ml-1">{provider.provider_name}</small>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              
                              {/* Rent Options */}
                              {watchProviders.providers.rent && watchProviders.providers.rent.length > 0 && (
                                <div className="col-12 mb-2">
                                  <small className="text-muted">Rent:</small>
                                  <div className="d-flex flex-wrap">
                                    {watchProviders.providers.rent.map((provider, index) => (
                                      <div key={index} className="provider-item mr-2 mb-1">
                                        <img
                                          src={provider.logo_path ? `https://image.tmdb.org/t/p/w45${provider.logo_path}` : ''}
                                          alt={provider.provider_name}
                                          className="provider-logo"
                                          style={{width: '30px', height: '30px', objectFit: 'contain'}}
                                        />
                                        <small className="text-white ml-1">{provider.provider_name}</small>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              
                              {/* Buy Options */}
                              {watchProviders.providers.buy && watchProviders.providers.buy.length > 0 && (
                                <div className="col-12 mb-2">
                                  <small className="text-muted">Buy:</small>
                                  <div className="d-flex flex-wrap">
                                    {watchProviders.providers.buy.map((provider, index) => (
                                      <div key={index} className="provider-item mr-2 mb-1">
                                        <img
                                          src={provider.logo_path ? `https://image.tmdb.org/t/p/w45${provider.logo_path}` : ''}
                                          alt={provider.provider_name}
                                          className="provider-logo"
                                          style={{width: '30px', height: '30px', objectFit: 'contain'}}
                                        />
                                        <small className="text-white ml-1">{provider.provider_name}</small>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              
                              {/* No providers available */}
                              {!watchProviders.providers.flatrate?.length && 
                               !watchProviders.providers.free?.length && 
                               !watchProviders.providers.rent?.length && 
                               !watchProviders.providers.buy?.length && (
                                <div className="col-12">
                                  <small className="text-muted">No streaming providers available</small>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="streamit-content-details trending-info g-border iq-rtl-direction">
                <ul
                  className="trending-pills-header d-flex nav nav-pills align-items-center text-center mb-5 justify-content-center"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === "description" ? "active show" : ""
                      }`}
                      onClick={() => handleTabClick("description")}
                      data-toggle="pill"
                      href="#dectripton-1"
                      role="tab"
                      aria-selected={activeTab === "description"}
                    >
                      Description
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === "review" ? "active show" : ""
                      }`}
                      onClick={() => handleTabClick("review")}
                      data-toggle="pill"
                      href="#reviw-1"
                      role="tab"
                      aria-selected={activeTab === "review"}
                    >
                      Rate & Review
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === "source" ? "active show" : ""
                      }`}
                      onClick={() => handleTabClick("source")}
                      data-toggle="pill"
                      href="#sourse-1"
                      role="tab"
                      aria-selected={activeTab === "source"}
                    >
                      Sources
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    id="dectripton-1"
                    className={`tab-pane fade ${
                      activeTab === "description" ? "active show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div className="description-content">
                      <p>{tmdbMovie.overview || "No description available."}</p>
                    </div>
                  </div>
                  <div
                    id="reviw-1"
                    className={`tab-pane fade ${
                      activeTab === "review" ? "active show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div id="reviews" className="streamit-reviews">
                      <div
                        id="comments"
                        className="comments-area validate-form"
                      >
                        {movieReviews.loading ? (
                          <div className="text-center d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Loading reviews...</span>
                            </div>
                            <p className="text-white mt-3 ml-3">Loading reviews...</p>
                          </div>
                        ) : movieReviews.error ? (
                          <div className="text-center">
                            <p className="text-white">Error loading reviews: {movieReviews.error}</p>
                            <button 
                              className="btn btn-primary mt-2" 
                              onClick={() => fetchMovieReviews(routeMovieId)}
                            >
                              Retry
                            </button>
                          </div>
                        ) : movieReviews.reviews && movieReviews.reviews.length > 0 ? (
                          <div className="reviews-list">
                            {movieReviews.reviews.map((review, index) => (
                              <div key={review.id || index} className="review-item mb-4 p-3" style={{border: '1px solid #333', borderRadius: '8px', backgroundColor: 'rgba(255,255,255,0.05)'}}>
                                <div className="review-header d-flex align-items-center mb-3">
                                  <img
                                    src={review.avatar_url}
                                    alt={review.author}
                                    className="rounded-circle mr-3"
                                    style={{width: '45px', height: '45px', objectFit: 'cover'}}
                                  />
                                  <div>
                                    <h6 className="text-white mb-1">{review.author}</h6>
                                    <div className="d-flex align-items-center">
                                      {review.rating && (
                                        <div className="star-rating mr-2">
                                          {[...Array(5)].map((_, i) => (
                                            <span key={i} className={i < Math.floor(review.rating / 2) ? 'text-warning' : 'text-muted'}>
                                              <i className="ri-star-fill"></i>
                                            </span>
                                          ))}
                                          <span className="text-white ml-2">({review.rating}/10)</span>
                                        </div>
                                      )}
                                      <small className="text-muted">
                                        {review.created_at ? new Date(review.created_at).toLocaleDateString() : ''}
                                      </small>
                                    </div>
                                  </div>
                                </div>
                                <div className="review-content">
                                  <p className="text-white-75 mb-0" style={{lineHeight: '1.6'}}>
                                    {review.content.length > 500 
                                      ? `${review.content.substring(0, 500)}...` 
                                      : review.content
                                    }
                                  </p>
                                  {review.content.length > 500 && (
                                    <button 
                                      className="btn btn-link p-0 mt-2 text-primary"
                                      onClick={(e) => {
                                        const fullContent = e.target.previousElementSibling;
                                        if (fullContent.textContent.includes('...')) {
                                          fullContent.textContent = review.content;
                                          e.target.textContent = 'Show less';
                                        } else {
                                          fullContent.textContent = `${review.content.substring(0, 500)}...`;
                                          e.target.textContent = 'Read more';
                                        }
                                      }}
                                    >
                                      Read more
                                    </button>
                                  )}
                                </div>
                                {review.url && (
                                  <div className="review-footer mt-2">
                                    <a 
                                      href={review.url} 
                                      target="_blank" 
                                      rel="noopener noreferrer"
                                      className="text-primary small"
                                    >
                                      View on TMDB <i className="ri-external-link-line"></i>
                                    </a>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="masvideos-noreviews mt-3 text-center">
                            There are no reviews yet for this movie.
                          </p>
                        )}
                      </div>
                      <div id="review_form_wrapper">
                        <div id="review_form">
                          <div id="respond" className="comment-respond">
                            <h3
                              id="reply-title"
                              className="comment-reply-title mt-0"
                            >
                              Be the first to review "{tmdbMovie.title || 'This Movie'}"
                            </h3>
                            <form className="comment-form" onSubmit={handleFormSubmit}>
                              <p className="comment-notes">
                                <span id="email-notes">
                                  Your email address will not be published.
                                </span>
                                <span
                                  className="required-field-message"
                                  aria-hidden="true"
                                >
                                  Required fields are marked
                                  <span className="required" aria-hidden="true">
                                    *
                                  </span>
                                </span>
                              </p>
                              
                              {/* User Rating Status */}
                              {userRating.hasRated && (
                                <div className="alert alert-success mb-3" style={{backgroundColor: 'rgba(40, 167, 69, 0.1)', border: '1px solid rgba(40, 167, 69, 0.3)', color: '#28a745'}}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span>
                                      <i className="ri-check-line mr-2"></i>
                                      You rated this movie {userRating.rating}/10
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => deleteRating(routeMovieId)}
                                      disabled={userRating.deleting}
                                    >
                                      {userRating.deleting ? (
                                        <>
                                          <i className="fa fa-spinner fa-spin mr-1"></i>
                                          Deleting...
                                        </>
                                      ) : (
                                        <>
                                          <i className="ri-delete-bin-line mr-1"></i>
                                          Delete Rating
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}

                              {/* Error Message */}
                              {userRating.error && (
                                <div className="alert alert-danger mb-3" style={{backgroundColor: 'rgba(220, 53, 69, 0.1)', border: '1px solid rgba(220, 53, 69, 0.3)', color: '#dc3545'}}>
                                  <i className="ri-error-warning-line mr-2"></i>
                                  {userRating.error}
                                </div>
                              )}

                              <div className="comment-form-rating">
                                <label htmlFor="rating">Your rating</label>
                                <div className="star ml-3">
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                      key={star}
                                      onClick={() => handleStarClick(star * 2)}
                                      style={{ cursor: 'pointer', marginRight: '5px' }}
                                      className={formData.rating >= star * 2 ? 'text-warning' : 'text-muted'}
                                    >
                                      <i className={formData.rating >= star * 2 ? 'ri-star-fill' : 'ri-star-line'}></i>
                                    </span>
                                  ))}
                                  <span className="text-white ml-2">
                                    ({formData.rating}/10)
                                  </span>
                                </div>
                              </div>
                              <p className="comment-form-comment p-0 mb-3 mt-0">
                                <label htmlFor="comment">
                                  Your review&nbsp;
                                  <span className="required">*</span>
                                </label>
                                <textarea
                                  id="comment"
                                  name="comment"
                                  cols="45"
                                  rows="8"
                                  value={formData.comment}
                                  onChange={handleInputChange}
                                  required=""
                                ></textarea>
                              </p>
                              <p className="comment-form-author mt-3 pr-lg-3 pr-0">
                                <label htmlFor="author">
                                  Name&nbsp;<span className="required">*</span>
                                </label>
                                <input
                                  id="author"
                                  name="author"
                                  type="text"
                                  value={formData.author}
                                  onChange={handleInputChange}
                                  size="30"
                                  required=""
                                />
                              </p>
                              <p className="comment-form-email mt-3 pl-lg-3 pl-0">
                                <label htmlFor="email">
                                  Email&nbsp;<span className="required">*</span>
                                </label>
                                <input
                                  id="email"
                                  name="email"
                                  type="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  size="30"
                                  required=""
                                />
                              </p>
                              <p className="comment-form-cookies-consent">
                                <input
                                  id="coment-check"
                                  name="coment-check"
                                  type="checkbox"
                                  value="yes"
                                />
                                <label for="coment-check">
                                  Save my name, email, and website in this
                                  browser for the next time I comment.
                                </label>
                              </p>
                              <p className="form-submit">
                                <button
                                  name="submit"
                                  type="submit"
                                  id="submit"
                                  className="btn btn-hover iq-button"
                                  value="Submit"
                                  disabled={userRating.submitting || userRating.hasRated}
                                >
                                  <span>
                                    {userRating.submitting ? (
                                      <>
                                        <i className="fa fa-spinner fa-spin mr-2"></i>
                                        Submitting Rating...
                                      </>
                                    ) : userRating.hasRated ? (
                                      <>
                                        <i className="ri-check-line mr-2"></i>
                                        Rating Submitted
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-star-fill mr-2"></i>
                                        Submit Rating
                                      </>
                                    )}
                                  </span>
                                </button>
                              </p>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="clear"></div>
                    </div>
                  </div>
                  <div
                    id="sourse-1"
                    className={`tab-pane fade ${
                      activeTab === "source" ? "active show" : ""
                    }`}
                    role="tabpanel"
                  >
                    <div className="source-list-content">
                      <table className="movie-sources sources-table">
                        <thead className="trending-pills">
                          <tr>
                            <th className="genres-table-heading">Links</th>
                            <th className="genres-table-heading">Quality</th>
                            <th className="genres-table-heading">Language</th>
                            <th className="genres-table-heading">Player</th>
                            <th className="genres-table-heading">Date Added</th>
                          </tr>
                        </thead>
                        <tbody className="trending-pills">
                          <tr>
                            <td>
                              <a
                                href="movie-details.html"
                                className="play-source movie-play-source btn-hover iq-button"
                              >
                                <i className="ri-play-fill"></i>
                                Play Now
                              </a>
                            </td>
                            <td>1080p</td>
                            <td>english</td>
                            <td>MediaMonkey</td>
                            <td>2021-12-04</td>
                          </tr>
                          <tr>
                            <td>
                              <a
                                href="movie-details.html"
                                className="play-source movie-play-source btn-hover iq-button"
                              >
                                <i className="ri-play-fill"></i>
                                Play Now
                              </a>
                            </td>
                            <td>800p</td>
                            <td>english</td>
                            <td>MusicBee</td>
                            <td>2021-12-02</td>
                          </tr>
                          <tr>
                            <td>
                              <a
                                href="movie-details.html"
                                className="play-source movie-play-source btn-hover iq-button"
                              >
                                <i className="ri-play-fill"></i>
                                Play Now
                              </a>
                            </td>
                            <td>720p</td>
                            <td>english</td>
                            <td>PotPlayer</td>
                            <td>2021-11-28</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="iq-favorites"
          className="s-margin detail-cast-list iq-rtl-direction starring"
        >
          <div className="container-fluid">
            <div className="row m-0">
              <div className="col-sm-12 overflow-hidden p-0">
                <div className="iq-main-header d-flex align-items-center justify-content-between iq-ltr-direction">
                  <h4 className="main-title">Starring</h4>
                </div>
              </div>
            </div>
            <ul className="inner-slider list-inline row p-0  iq-ltr-direction">
              {movieCredits.loading ? (
                <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{height: '200px'}}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading cast...</span>
                  </div>
                  <p className="text-white mt-3 ml-3">Loading cast information...</p>
                </div>
              ) : movieCredits.error ? (
                <div className="col-12 text-center">
                  <p className="text-white">Error loading cast: {movieCredits.error}</p>
                  <button 
                    className="btn btn-primary mt-2" 
                    onClick={() => fetchMovieCredits(routeMovieId)}
                  >
                    Retry
                  </button>
                </div>
              ) : movieCredits.cast && movieCredits.cast.length > 0 ? (
                movieCredits.cast.map((actor, index) => (
                  <li key={actor.id || index} className="slide-item iq-ltr-direction col-xl-3 col-lg-4 col-md-4 col-6">
                    <div className="cast-images position-relative row mx-0">
                      <div className="col-sm-4 col-12 img-box p-0">
                        <img
                          src={actor.profile_image_url}
                          className="person__poster--image img-fluid"
                          alt={actor.name}
                          loading="lazy"
                          style={{width: '100%', height: 'auto', objectFit: 'cover'}}
                        />
                      </div>
                      <div
                        className="col-sm-8 col-12 block-description starring-desc"
                        style={{
                          marginLeft: "90px",
                        }}
                      >
                        <h6 className="iq-title">
                          <Link to="#" tabIndex="0">
                            {actor.name}
                          </Link>
                        </h6>
                        <div
                          className="video-time align-items-center my-2"
                          style={{ textAlign: "center" }}
                        >
                          <span className="text-white">As {actor.character}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <div className="col-12 text-center">
                  <p className="text-white">No cast information available</p>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* <section id="iq-upcoming-movie" className="my-5">
        <Container fluid>
          <Row>
            <Col sm="12" className="overflow-hidden">
              <div className="d-flex align-items-center justify-content-between mt-3">
                <h4 className="main-title">Recommended Movies</h4>
                <Link className="iq-view-all" to="/movie-category">
                  View All
                </Link>
              </div>
              <div id="upcoming-contens">
                <div id="prev1" className="swiper-button swiper-button-prev">
                  <i className="fa fa-chevron-left"></i>
                </div>
                <div id="next1" className="swiper-button swiper-button-next">
                  <i className="fa fa-chevron-right"></i>
                </div>
                <Swiper
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    550: { slidesPerView: 2 },
                    991: { slidesPerView: 3 },
                    1400: { slidesPerView: 4 },
                  }}
                  navigation={{
                    prevEl: "#prev1",
                    nextEl: "#next1",
                  }}
                  loop={true}
                  slidesPerView={4}
                  spaceBetween={20}
                  as="ul"
                  className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                >
                  {upcomingData.map((item, index) => (
                    <SwiperSlide as="li" key={index}>
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img
                            src={item?.imageUrl}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">{item?.title}</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                            <div className="badge badge-secondary p-1 mr-2">
                              {item?.ageRating}
                            </div>
                            <span className="text-white">{item?.duration}</span>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover iq-button"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <li>
                              <span onClick={()=>handleAddClick('Liked Successfully !')}>
                                <i className="ri-heart-fill"></i>
                              </span>
                              <span className="count-box">19+</span>
                            </li>
                            <li>
                              <span onClick={()=>handleAddClick('Added Successfully !')}>
                                <i className="ri-add-line"></i>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      <section id="iq-rtl-direction" className="my-5">
        <Container fluid>
          <Row>
            <Col sm="12" className="overflow-hidden">
              <div className="d-flex align-items-center justify-content-between mt-3">
                <h4 className="main-title">Related Movies</h4>
                <Link className="iq-view-all" to="/movie-category">
                  View All
                </Link>
              </div>
              <div id="upcoming-contens">
                <div id="prev2" className="swiper-button swiper-button-prev">
                  <i className="fa fa-chevron-left"></i>
                </div>
                <div id="next2" className="swiper-button swiper-button-next">
                  <i className="fa fa-chevron-right"></i>
                </div>
                <Swiper
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    550: { slidesPerView: 2 },
                    991: { slidesPerView: 3 },
                    1400: { slidesPerView: 4 },
                  }}
                  navigation={{
                    prevEl: "#prev2",
                    nextEl: "#next2",
                  }}
                  loop={true}
                  slidesPerView={4}
                  spaceBetween={20}
                  as="ul"
                  className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                >
                  {similarMovies.loading ? (
                    <div className="col-12 text-center d-flex justify-content-center align-items-center" style={{height: '300px'}}>
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="text-white mt-3 ml-3">Loading similar movies...</p>
                    </div>
                  ) : similarMovies.error ? (
                    <div className="col-12 text-center">
                      <p className="text-white">Error: {similarMovies.error}</p>
                      <button 
                        className="btn btn-primary mt-2" 
                        onClick={() => fetchSimilarMovies(routeMovieId)}
                      >
                        Retry
                      </button>
                    </div>
                  ) : similarMovies.movies && similarMovies.movies.length > 0 ? (
                    similarMovies.movies.map((item, index) => (
                      <SwiperSlide as="li" key={item.id || index}>
                        <div className=" block-images position-relative">
                          <div className="img-box" >
                            <img
                              src={item?.imageUrl}
                              className="img-fluid"
                              style={{width: '100%', height: '200px', objectFit: 'cover'}}
                              alt={item?.title || "Movie"}
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                              <Link to={`/movie-details/${item.id}`} onClick={handleLinkClick}>{item?.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                              <div className="badge badge-secondary p-1 mr-2">
                                {item?.ageRating}
                              </div>
                              <span className="text-white">{item?.duration}</span>
                            </div>
                            <div className="hover-buttons">
                              <Link
                                to={`/movie-details/${item.id}`}
                                role="button"
                                className="btn btn-hover iq-button"
                                onClick={handleLinkClick}
                              >
                                <i
                                  className="fa fa-play mr-1"
                                  aria-hidden="true"
                                ></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                      href={`https://www.facebook.com/sharer?u=${window.location.href}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href={`https://twitter.com/intent/tweet?text=${encodeURIComponent('Check this out: ' + (item?.title || ''))}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                      onClick={copyURL}
                                      data-link={window.location.href}
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <li>
                                <span onClick={()=>handleAddClick('Liked Successfully !')}>
                                  <i className="ri-heart-fill"></i>
                                </span>
                                <span className="count-box">19+</span>
                              </li>
                              <li>
                                <span onClick={()=>handleAddClick('Added Successfully !')}>
                                  <i className="ri-add-line"></i>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <div className="col-12 text-center">
                      <p className="text-white">No similar movies available</p>
                    </div>
                  )}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section id="iq-rtl-direction" className="my-5">
        <Container fluid>
          <Row>
            <Col sm="12" className="overflow-hidden">
              <div className="d-flex align-items-center justify-content-between mt-3">
                <h4 className="main-title">Upcoming Movies</h4>
                <Link className="iq-view-all" to="/movie-category">
                  View All
                </Link>
              </div>
              <div id="upcoming-contens">
                <div id="prev3" className="swiper-button swiper-button-prev">
                  <i className="fa fa-chevron-left"></i>
                </div>
                <div id="next3" className="swiper-button swiper-button-next">
                  <i className="fa fa-chevron-right"></i>
                </div>
                <Swiper
                  breakpoints={{
                    320: { slidesPerView: 1 },
                    550: { slidesPerView: 2 },
                    991: { slidesPerView: 3 },
                    1400: { slidesPerView: 4 },
                  }}
                  navigation={{
                    prevEl: "#prev3",
                    nextEl: "#next3",
                  }}
                  loop={true}
                  slidesPerView={4}
                  spaceBetween={20}
                  as="ul"
                  className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                >
                  {related.map((item, index) => (
                    <SwiperSlide as="li" key={index}>
                      <div className=" block-images position-relative">
                        <div className="img-box">
                          <img
                            src={item?.imageUrl}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                        <div className="block-description">
                          <h6 className="iq-title">
                            <Link to="/movie-details">{item?.title}</Link>
                          </h6>
                          <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                            <div className="badge badge-secondary p-1 mr-2">
                              {item?.ageRating}
                            </div>
                            <span className="text-white">{item?.duration}</span>
                          </div>
                          <div className="hover-buttons">
                            <Link
                              to="/movie-details"
                              role="button"
                              className="btn btn-hover iq-button"
                            >
                              <i
                                className="fa fa-play mr-1"
                                aria-hidden="true"
                              ></i>
                              Play Now
                            </Link>
                          </div>
                        </div>
                        <div className="block-social-info">
                          <ul className="list-inline p-0 m-0 music-play-lists">
                            <li className="share">
                              <span>
                                <i className="ri-share-fill"></i>
                              </span>
                              <div className="share-box">
                                <div className="d-flex align-items-center">
                                  <a
                                    href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-facebook-fill"></i>
                                  </a>
                                  <a
                                    href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-ico"
                                    tabIndex="0"
                                  >
                                    <i className="ri-twitter-fill"></i>
                                  </a>
                                  <a
                                     onClick={copyURL}
                                    data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                    className="share-ico iq-copy-link"
                                    tabIndex="0"
                                  >
                                    <i className="ri-links-fill"></i>
                                  </a>
                                </div>
                              </div>
                            </li>
                            <li>
                              <span onClick={()=>handleAddClick('Liked Successfully !')}>
                                <i className="ri-heart-fill"></i>
                              </span>
                              <span className="count-box">19+</span>
                            </li>
                            <li>
                              <span onClick={()=>handleAddClick('Added Successfully !')}>
                                <i className="ri-add-line"></i>
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      {/* <section id="iq-related-movie">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <h4 className="main-title">Upcoming Movies</h4>
                  <Link className="iq-view-all" to="/movie-category">
                    View All
                  </Link>
                </div>
                <div id="upcoming-contens">
                  <div id="prev1" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next1" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    navigation={{
                      prevEl: "#prev1",
                      nextEl: "#next1",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {related.map((item, index) => (
                      <SwiperSlide as="li" key={index}>
                        <div className=" block-images position-relative">
                          <div className="img-box">
                            <img
                              src={item?.imageUrl}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                              <Link to="/movie-details">{item?.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                              <div className="badge badge-secondary p-1 mr-2">
                                {item?.ageRating}
                              </div>
                              <span className="text-white">
                                {item?.duration}
                              </span>
                            </div>
                            <div className="hover-buttons">
                              <Link
                                to="/movie-details"
                                role="button"
                                className="btn btn-hover iq-button"
                              >
                                <i
                                  className="fa fa-play mr-1"
                                  aria-hidden="true"
                                ></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
            <span><i className="ri-share-fill"></i></span>
            <div className="share-box">
               <div className="d-flex align-items-center">
                  <Link to="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/" target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0"><i className="ri-facebook-fill"></i></Link>
                  <Link to="https://twitter.com/intent/tweet?text=Currentlyreading" target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0"><i className="ri-twitter-fill"></i></Link>
                  <Link to="#" data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/" className="share-ico iq-copy-link" tabIndex="0"><i className="ri-links-fill"></i></Link>
               </div>
            </div>
         </li>
                              <li>
                                <span>
                                  <i className="ri-heart-fill"></i>
                                </span>
                                <span className="count-box">19+</span>
                              </li>
                              <li><span><i className="ri-add-line"></i></span></li>
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    )}
                  ) : (
                    <div className="col-12 text-center">
                      <p className="text-white">No similar movies available</p>
                    </div>
                  )}
                </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}

      <div className="rtl-box">
        <button type="button" className="btn btn-light rtl-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30px"
            height="30px"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fill-rule="evenodd"
              d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <div className="rtl-panel">
          <ul className="modes">
            <li
              className="dir-btn"
              data-mode="rtl"
              data-active="false"
              data-value="ltr"
            >
              <a href="#">LTR</a>
            </li>
            <li
              className="dir-btn"
              data-mode="rtl"
              data-active="true"
              data-value="rtl"
            >
              <a href="#">RTL</a>
            </li>
          </ul>
        </div>
      </div>
        </>
      )}

      {/* Video Player Modal */}
        {/* Full-Screen Video Player Modal */}
        {showFullScreenPlayer && selectedVideo && (
          <div 
            className="fullscreen-video-modal" 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.95)',
              zIndex: 99999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(5px)'
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowFullScreenPlayer(false);
              }
            }}
          >
            <div style={{
              position: 'relative',
              width: '95%',
              height: '90%',
              maxWidth: '1400px',
              maxHeight: '900px'
            }}>
              {/* Close Button */}
              <button
                onClick={() => setShowFullScreenPlayer(false)}
                style={{
                  position: 'absolute',
                  top: '-50px',
                  right: '0',
                  background: 'rgba(0, 0, 0, 0.7)',
                  border: 'none',
                  color: 'white',
                  fontSize: '28px',
                  cursor: 'pointer',
                  zIndex: 100000,
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255, 0, 0, 0.8)';
                  e.target.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(0, 0, 0, 0.7)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                ✕
              </button>

              {/* Movie Title */}
              <div style={{
                position: 'absolute',
                top: '-50px',
                left: '0',
                color: 'white',
                fontSize: '24px',
                fontWeight: 'bold',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                zIndex: 100000
              }}>
                {tmdbMovie.title || 'Movie Player'}
              </div>

              {/* Video Player */}
              <div style={{
                width: '100%',
                height: '100%',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
              }}>
                <ReactPlayer
                  url={`https://www.youtube.com/watch?v=${selectedVideo.key}`}
                  width="100%"
                  height="100%"
                  controls={true}
                  playing={true}
                  config={{
                    youtube: {
                      playerVars: {
                        autoplay: 1,
                        controls: 1,
                        rel: 0,
                        modestbranding: 1,
                        showinfo: 0
                      }
                    }
                  }}
                />
              </div>

              {/* Video Info */}
              <div style={{
                position: 'absolute',
                bottom: '-50px',
                left: '0',
                color: 'white',
                fontSize: '14px',
                opacity: 0.8
              }}>
                {selectedVideo.type} • {selectedVideo.name || 'Video'}
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default MovieDetails;
